import React, { Component } from "react";
import CustomLoader from "../../common/Loader";
import _ from 'lodash';
import { ListGroup, ListGroupItem } from 'react-bootstrap';
import { Modal } from "react-bootstrap";
import { withRouter } from 'react-router-dom';
import { loadInfo } from "../../../services/formService";
import { getProjectForms } from '../../../services/projectService';
import { RowActions } from '../../../constants/ResultSource';
import FormViewer from '../FormViewer';
import { WidgetTypes } from "../../../constants/QuestionTypes";
import { Custom_Forms } from "../../../config";
import {BASE_URL} from "../../../auth/authConfig";
import {Markup} from "interweave";

class InfoViewer extends Component {
  state = {
    Widget_ID: this.props.Widget_ID,
    Widget_Type_ID: this.props.Widget_Type_ID,
    Form_ID: this.props.Form_ID ? this.props.Form_ID : 0,
    Display_Name: "",
    Content: "",
    loading: true,
    pk_col: this.props.PrimaryKey ? this.props.PrimaryKey : '',
		content: null,
		PrimaryKey: this.props.PrimaryKey ? this.props.PrimaryKey : '',
		Project_ID: this.props.Project_ID ? this.props.Project_ID : 0,
		LightMode: this.props.LightMode,
    Action_ID: 0,
		Action_Form_ID: 0,
    borderColor: this.props.Widget_Color ? this.props.Widget_Color : '#0061f2',
    dataElements: this.props.dataElements ? this.props.dataElements : undefined,
    infoConfig: this.props.infoConfig ? this.props.infoConfig : undefined,
    sharedDataElement: this.props.sharedDataElement ? this.props.sharedDataElement : undefined,
    resultSource: this.props.resultSource ? this.props.resultSource : undefined,
    open: false
  };

  constructor(props){
    super(props);
    this.handleClick = this.handleClick.bind(this)
    this.handleNavigate = this.handleNavigate.bind(this)
  }

  async componentDidMount() {
    try {
      //Shared Data Element method 
      if (this.state.sharedDataElement) {
        let infoConfig = (this.state.infoConfig).filter((infoEl) => infoEl.Widget_ID === this.state.Widget_ID)[0] || [];
        this.setState({
          Display_Name: infoConfig.Display_Name,
          Content: this.state.sharedDataElement ? String(this.state.sharedDataElement[0]['spResult'][0][this.state.resultSource.Column_Name]) : undefined,
          Action_ID: infoConfig.Action_ID,
          Action_Form_ID: infoConfig.Action_Form_ID,
          borderColor: infoConfig.Widget_Color
        });
      }
      //Traditional method 
      else {
        const { data } = await loadInfo(this.state.Widget_ID, localStorage.getItem('Inst_ID'));
        if (typeof data === "object") {
          this.setState({ Display_Name: data.Info.Display_Name });
          if ("Content" in data) {
            this.setState({ Content: String(data.Content) }); // Markup requires content to be string
          } else {
            this.setState({ Content: data.Info.ResultSource_Content });
          }
          this.setState({ Action_ID: data.Info.Action_ID, Action_Form_ID: data.Info.Action_Form_ID })
        }
      }
      this.getInstCode();
    }
    catch (e) {
      console.error('Error loading Info widget')
    }
    //console.log('state', this.state);
    this.setState({ loading: false });
  }

  getInstCode() {
    let institutionElId = document.getElementById('userInst').value;
    this.setState({ selectedInst: institutionElId });
    return institutionElId;
  }

  handleClick = (e) => {
    const { pk_col, Action_Form_ID, Project_ID } = this.state;
      if (this.state.Action_ID === RowActions.Navigate && Action_Form_ID !== 0) {
        this.handleNavigate(Action_Form_ID, pk_col, Project_ID);
      } else {
        (Action_Form_ID !== 0) && this.setState({ open: true });
        let content = null;
        if (this.state.Action_ID === RowActions.Show) {
          content = <FormViewer Form_ID={Action_Form_ID} LightMode={true} source={'customButton'} PrimaryKey={pk_col} isPopUp={true} Form_BehaviorOnSave={Action_Form_ID == Custom_Forms.addAeSaeEvent ? Custom_Forms.onSaveSae : undefined} Project_ID={this.state.Project_ID} PK_Name={'Participant ID'} selectedInst={this.state.selectedInst}/>;
        } else if (this.state.Action_ID === RowActions.Navigate) {
          content = (
            <ListGroup>
              {this.state.Project_Forms.map((form) => (
                <ListGroupItem action key={'nav' + form.Form_ID} onClick={() => this.handleNavigate(form.Form_ID, pk_col, this.state.Project_ID)}>
                  {form.Form_Name}
                </ListGroupItem>
              ))}
            </ListGroup>
          );
        }
        this.setState({ content });
      }
  };

  handleNavigate = (Form_ID, pk, Project_ID) => {
		window.location = BASE_URL+`form?form_id=${Form_ID}&project_id=${document.getElementById('projectSelected').getAttribute('name')}&inst_id=${this.state.selectedInst}`;
	};

  handleClickAway = () => {
    this.setState({ open: false });
  };

  render() {
    const { Display_Name, Content, content, loading, Widget_ID, borderColor } = this.state;
    if (loading) {
      return <CustomLoader loading={this.state.loading} />;
    }
    return (
      <div>
        <div id={this.props.Col_ID ? this.props.Col_ID : Widget_ID} className={'card border-lg pointer'} onClick={(e) => this.handleClick(e)} style={{ 'borderColor': borderColor }}>
          <div className="card-body">
            <div className="flex-grow-1">
              <div className="small font-weight-bold text-primary mb-1">
                {Display_Name}
              </div>
              <Markup tagName='h5' content={Content} />
            </div>
          </div>
        </div>
        <Modal size='xxl' show={this.state.open} onHide={() => { this.setState({ open: false }); }}>
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body className='container'>{content}</Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default withRouter(InfoViewer);
